var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFichaSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.075,
    height: 24.249,
    viewBox: "0 0 20.075 24.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ficha_Tecnica",
    "data-name": "Ficha Tecnica",
    transform: "translate(-52.634 -16.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-1",
    d: "M71.187,16.073H54.155a1.523,1.523,0,0,0-1.521,1.521V38.8a1.523,1.523,0,0,0,1.521,1.521H71.189a1.52,1.52,0,0,0,1.52-1.521V17.594A1.523,1.523,0,0,0,71.187,16.073ZM53.923,17.594a.232.232,0,0,1,.232-.232H71.187a.232.232,0,0,1,.232.232V38.8a.233.233,0,0,1-.232.231H54.155a.232.232,0,0,1-.232-.231Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-1",
    d: "M57.93,38.063h9.493a.656.656,0,0,0,.512-.284,1.154,1.154,0,0,0-.009-1.334.7.7,0,0,0-.514-.27H57.926a.978.978,0,0,0,0,1.888Z",
    transform: "translate(0 -3.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-1",
    d: "M57.93,33.2h9.492a.648.648,0,0,0,.512-.282,1.154,1.154,0,0,0-.008-1.335.714.714,0,0,0-.514-.271H57.925a.865.865,0,0,0-.719.954,1.1,1.1,0,0,0,.218.665A.65.65,0,0,0,57.93,33.2Z",
    transform: "translate(0 -2.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-1",
    d: "M57.94,28.695h9.47a.86.86,0,0,0,.718-.934,1.1,1.1,0,0,0-.208-.671.652.652,0,0,0-.513-.282h-9.47a.859.859,0,0,0-.719.934,1.1,1.1,0,0,0,.207.67A.657.657,0,0,0,57.94,28.695Z",
    transform: "translate(0 -1.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-1",
    d: "M57.94,24.186h9.47a.862.862,0,0,0,.718-.935,1.1,1.1,0,0,0-.208-.671.652.652,0,0,0-.513-.282h-9.47a.86.86,0,0,0-.719.934,1.1,1.1,0,0,0,.207.67A.658.658,0,0,0,57.94,24.186Z",
    transform: "translate(0 -0.937)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFichaSelected);
export default __webpack_public_path__ + "static/media/ficha-selected.018097123f96f7e399cebb369936a064.svg";
export { ForwardRef as ReactComponent };